import { edges, type Edges } from "@proof/core";
import { Control } from "./components";
export function InsetsControl({
  label,
  value,
  onChange,
  max = 14400,
}: {
  label: string;
  value: number | Edges;
  onChange: (value: number | Edges) => void;
  max?: number;
}) {
  const e = edges(value);
  return (
    <>
      <Control label={`${label} mode`}>
        <select
          value={typeof value === "number" ? "uniform" : "individual"}
          onChange={(event) =>
            onChange(event.target.value === "uniform" ? e.top : e)
          }
        >
          <option value="uniform">Uniform</option>
          <option value="individual">Individual sides</option>
        </select>
      </Control>
      {typeof value === "number" ? (
        <Control label={`${label} (pt)`}>
          <input
            type="number"
            min={0}
            max={max}
            value={value}
            onChange={(event) => onChange(Number(event.target.value))}
          />
        </Control>
      ) : (
        <div className="control-grid">
          {(["top", "right", "bottom", "left"] as const).map((side) => (
            <Control key={side} label={`${label} ${side} (pt)`}>
              <input
                type="number"
                min={0}
                max={max}
                value={e[side]}
                onChange={(event) =>
                  onChange({ ...e, [side]: Number(event.target.value) })
                }
              />
            </Control>
          ))}
        </div>
      )}
    </>
  );
}
